import { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faK,
  faKey,
  faPaperPlane,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import ChangeUserPassword from "./changeUserPassword";
import urls from "../../urls";
import { showError, showSuccess } from "../../utils";
import { deleteUser } from "../../redux-state/features/users";
import axios from "axios";
class UserTableItem extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      showChangePassword: false,
    };
    this.usersTypes = {
      admin: "مدير البرنامج",
      store_manager: "أمين مخزن",
      user: "مستخدم",
      inventory_officer: "مسؤول الجرد",
      maintainer: "مسؤول صبانة ",
    };
  }

  handleDeleteUser = async (uuid) => {
    console.log(urls.deleteUser(uuid));

    axios
      .delete(urls.deleteUser(uuid))
      .then((res) => {
        this.props.deleteUser({ uuid });
        const msg = "تم حذف المستخدم بنجاح ";

        showSuccess(msg); // Success response
        console.log(res.data);
      })
      .catch((error) => {
        showError("حدث خطأ أثناء حذف المستخدم ");
        console.error("Error deleting user:", error);
      });
  };
  render() {
    const { showChangePassword } = this.state;
    const { full_name, email, user_type, uuid, account_status } =
      this.props.obj;
    const { userOrder } = this.props;
    const accountType = this.usersTypes[user_type];
    console.log(full_name, accountType);
    return (
      <tr className="text-center" style={{ fontSize: "12px" }}>
        <td style={{ width: "10%" }}>{userOrder}</td>
        <td>{full_name}</td>
        <td>{email}</td>
        <td>{accountType}</td>
        {showChangePassword && (
          <td>
            <ChangeUserPassword
              onCancel={() => this.setState({ showChangePassword: false })}
              uuid={uuid}
            />
          </td>
        )}
        {!showChangePassword && (
          <td>
            {/* <button className="btn border border-1 me-3">
              <FontAwesomeIcon
                icon={faPaperPlane}
                title="إرسال رسالة"
                size="lg"
              />
            </button> */}
            <button
              className="btn border border-1"
              onClick={() => this.setState({ showChangePassword: true })}
            >
              <FontAwesomeIcon
                icon={faKey}
                title="تغيير كلمة المرور "
                size="lg"
              />
            </button>
            <button
              className="btn border border-1 ms-3"
              onClick={() => this.handleDeleteUser(uuid)}
            >
              <FontAwesomeIcon
                icon={faTrashCan}
                title="حذف الحساب "
                size="lg"
              />
            </button>
          </td>
        )}
      </tr>
    );
  }
}

const mapDispatchToProps = { deleteUser };
const mapStateToProps = (state) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(UserTableItem);
